<template>
  <div>
    <b-alert show variant="danger">
      <h4 class="alert-heading">Not Found!</h4>
      <p>
        Aww yeah, you successfully read this important alert message. This example text is going to
        run a bit longer so that you can see how spacing within an alert works with this kind of
        content.
      </p>
      <hr>
      <p class="mb-0">
        Whenever you need to, be sure to use margin utilities to keep things nice and tidy.
      </p>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "404",
  metaInfo: {
    title: "404"
  }
};
</script>